import { connect } from 'react-redux'
import Moderation from './moderation'
import { fetchInvitationCounter } from '../../../stores/current-invitations/current-invitations.actions'
import { withMe } from 'pobble-components/dist/pobble-user'

const mapStateToProps = (state, { me }) => {
  const canManageAFs =
    me &&
    me.account &&
    me.account.policy &&
    me.account.policy.can_manage_assessment_files
  return {
    canManageAFs
  }
}

const mapDispatchToProps = dispatch => ({
  onMount: () => dispatch(fetchInvitationCounter())
})

export default withMe(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Moderation)
)
